import { Phone, MapPin, Lock } from "lucide-react";
import { useLang } from "@/lib/i18n";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Footer({ onNavigate }) {
  const { t } = useLang();
  return (
    <footer
      id="areas"
      className="bg-[#0E1A2B] grain relative overflow-hidden py-16 sm:py-24"
      data-testid="footer-section"
    >
      <div className="relative px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#F26522] font-semibold mb-4">
              {t("footer_eyebrow")}
            </p>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
              {t("footer_h")}
            </h2>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-slate-300">
              {t("footer_sub")}
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {["Centralia, WA", "Chehalis, WA", "Olympia, WA"].map((a) => (
                <span
                  key={a}
                  className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-2 text-sm text-slate-200"
                >
                  <MapPin className="h-4 w-4 text-[#F26522]" />
                  {a}
                </span>
              ))}
            </div>
            <a
              href="tel:3608617655"
              className="mt-8 inline-flex items-center gap-3 rounded-full bg-[#F26522] hover:bg-[#D85312] text-white font-display font-bold px-7 py-4 text-lg transition-[background-color,transform] duration-200 hover:scale-[1.04] active:scale-95"
              data-testid="footer-phone-link"
            >
              <Phone className="h-5 w-5" />
              {t("footer_call")}
            </a>
          </div>

          <div className="lg:col-span-5 flex justify-center">
            <img
              src="/logo.png"
              alt="PERETE Flooring and Carpet Installation Inc. seal"
              className="w-56 sm:w-64 rounded-full ring-4 ring-[#F26522]/60 shadow-[0_0_60px_-10px_rgba(242,101,34,0.5)]"
              data-testid="footer-logo-img"
            />
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
            © {new Date().getFullYear()} PERETE Flooring and Carpet
            Installation Inc.
          </p>
          <div className="flex items-center gap-6">
            <button
              onClick={startGoogleLogin}
              className="inline-flex items-center gap-2 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-[#F26522] transition-colors duration-200"
              data-testid="owner-login-btn"
            >
              <Lock className="h-3.5 w-3.5" />
              {t("owner_login")}
            </button>
            <button
              onClick={() => onNavigate("top")}
              className="py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-[#F26522] transition-colors duration-200"
              data-testid="footer-top-link"
            >
              {t("back_top")}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}